/**
 * zoomRefCore.js — правило «эталонного масштаба» для жестов на мобильном.
 *
 * Вынесено отдельно и без браузерных зависимостей, потому что дефект сидел
 * именно в этом правиле, а обработчики касаний тестом не покрыть.
 *
 * Смысл: у вьюпорта есть исходный (несжатый) parallelScale. Относительно него
 * считается и указатель масштаба, и решение двойного касания «сбросить или
 * приблизить». Эталон надо запоминать ДО первого приближения — иначе он
 * запоминается уже увеличенным и обе функции врут.
 */

/** Порог, ниже которого считаем вьюпорт приближённым (доля от эталона). */
export const ZOOMED_FRACTION = 0.6;

/**
 * Запомнить эталон, если он ещё не известен. Вызывать ПЕРЕД тем, как менять
 * масштаб текущим жестом.
 * @returns {number} действующий эталон
 */
export function ensureZoomRef(vp, currentScale) {
  if (!vp) return currentScale;
  if (!(vp._origParallelScale > 0)) vp._origParallelScale = currentScale;
  return vp._origParallelScale;
}

/** Принудительно переустановить эталон (после resetCamera масштаб — исходный). */
export function refreshZoomRef(vp, scaleAfterReset) {
  if (vp && scaleAfterReset > 0) vp._origParallelScale = scaleAfterReset;
  return vp ? vp._origParallelScale : scaleAfterReset;
}

/** Приближён ли вьюпорт сейчас (для решения двойного касания). */
export function isZoomedIn(currentScale, origScale, fraction = ZOOMED_FRACTION) {
  if (!(origScale > 0) || !(currentScale > 0)) return false;
  return currentScale < origScale * fraction;
}

/** Показание указателя масштаба в процентах от эталона. */
export function zoomPercent(origScale, currentScale) {
  if (!(origScale > 0) || !(currentScale > 0)) return 100;
  return Math.round((origScale / currentScale) * 100);
}

export default { ensureZoomRef, refreshZoomRef, isZoomedIn, zoomPercent, ZOOMED_FRACTION };
